<template>
  <ul
    class="flex flex-row gap-2 sm:gap-3 justify-between overflow-x-auto hide-scrollbar"
  >
    <li v-for="index in count" :key="index" class="flex-shrink-0">
      <div
        class="flex flex-col items-center gap-1.5 text-center cursor-pointer w-[100px]"
      >
        <!-- Avatar section with badge and country flag matching UserAvatarAndName structure -->
        <div class="flex flex-row justify-center w-full relative">
          <!-- Points badge (top-left) -->
          <div class="absolute top-0 -left-1 z-10 self-start">
            <Skeleton width="40px" height="40px" border-radius="50%" />
          </div>

          <!-- Main avatar -->
          <div class="relative h-[70px] aspect-square">
            <Skeleton width="70px" height="70px" border-radius="50%" />
          </div>

          <!-- Country badge (bottom-right) -->
          <div class="absolute bottom-0 -right-1">
            <Skeleton width="40px" height="40px" border-radius="50%" />
          </div>
        </div>

        <!-- Username with proper width -->
        <div class="w-full">
          <Skeleton
            :width="usernameWidths[index % usernameWidths.length]"
            height="16px"
            border-radius="4px"
          />
        </div>

        <!-- Activity description (short_title) -->
        <Skeleton
          :width="activityWidths[index % activityWidths.length]"
          height="12px"
          border-radius="4px"
        />

        <!-- Time (formattedDate) -->
        <Skeleton
          :width="timeWidths[index % timeWidths.length]"
          height="12px"
          border-radius="4px"
        />
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";

const _props = withDefaults(
  defineProps<{
    count?: number;
  }>(),
  {
    count: 8, // Default to showing 8 activity items
  },
);

const usernameWidths = ["65px", "80px", "55px", "70px", "60px"];
const activityWidths = ["70px", "85px", "60px", "75px", "80px"];
const timeWidths = ["40px", "50px", "35px", "45px", "55px"];
</script>
